import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0c6f7dcc&scoped=true"
import script from "./home.js?vue&type=script&lang=js&external"
export * from "./home.js?vue&type=script&lang=js&external"
import style0 from "./home.vue?vue&type=style&index=0&id=0c6f7dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f7dcc",
  null
  
)

export default component.exports